<template>
	<div>
		<autocomplete :search="search"
					  placeholder="Введите фразу"
					  aria-label="Введите фразу"
					  :get-result-value="getResultValue"
					  v-on:submit="handleSubmit">
			<template #result="{ result, props }">
				<li v-bind="props"
					class="autocomplete-result search-result">
					<div class="search-result-title">
						{{ result.name }} <span :class="result.badgeCssClass">{{result.type}}</span>
					</div>
					<div class="search-result-snippet" v-html="result.snippet"></div>
				</li>
			</template>
		</autocomplete>
	</div>
</template>

<script>
	import Vue from "Vue";
	import Autocomplete from "@trevoreyre/autocomplete-vue";
	import "@trevoreyre/autocomplete-vue/dist/style.css";
	import autocompleteMixin from "Mixin/autocomplete";

	Vue.use(Autocomplete);

	export default {
		name: "search-control",
		mixins: [autocompleteMixin],
		components: {
			Autocomplete
		}
	}
</script>